import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { User } from '@core/interfaces/user.interface';
import { UserProfileComponent } from '../user-profile/user-profile.component';

@Component({
  selector: 'app-user-profile-modal',
  imports: [UserProfileComponent],
  templateUrl: './user-profile-modal.component.html',
  styleUrl: './user-profile-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  host: {
    class: 'modal-container flex flex-col',
  },
})
export class UserProfileModalComponent {
  user = input.required<User>();
}
